<template>
  <section>
    <div class="container">
      <div class="card">
        <div>
          <div class="center">
            <br>
            <h1>Fiche article</h1>
            <br>
            <br>
            <span class="space20"></span>

            <div class="inside-card">
              <p>
                <b>Marque:</b>
                {{article.brand}}
              </p>
              <p>
                <b>Nomenclature/Famille:</b>
                {{article.nomenclature || "N.C"}}
              </p>
              <p>
                <b>Status:</b>
                {{article.disponibilite || "N.C"}}
              </p>
              <p>
                <b>Gamme:</b>
                {{article.gamme || "N.C"}}
              </p>
              <p>
                <b>EAN:</b>
                {{article.ean || "N.C"}}
              </p>
              <p>
                <b>Dénomiation commerciale:</b>
                {{article.commercial_names || "N.C"}}
              </p>
              <p>
                <b>Remplacée par:</b>
                <a v-if="article.replacing_part">{{article.replacing_part || "N.C"}}</a>
                <span v-else>N.C</span>
              </p>
              <br>
              <p>
                <b>Données techniques:</b>
              </p>
              <!-- {{article}} -->
              <b-table
                v-if="article.data && article.data.length"
                :data="article.data"
                :columns="columns"
              ></b-table>

              <div class="nodata center" v-else>
                <div>
                  <b-icon icon="emoticon-sad" size="is-large" type="is-primary"></b-icon>
                  <p>Pas de données à afficher</p>
                </div>
              </div>
              <br>
              <br>
              <br>
              <b-loading :active.sync="isLoading"></b-loading>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <h1>Bienvenue {{profile.getGivenName()}}</h1> -->
  </section>
</template>

<script lang="js">
import Vue from "vue";
export default  {
  name: 'ArticlePage',
  props: [],
  mounted() {
      var article_ref = this.$route.query.id;
      // alert(article_ref);
      var url = process.env.VUE_APP_API_URL + 'api/article';
      this.isLoading= true;
      this.axios.get(url, {
              params: {
                id: this.$route.query.id,
              },
              responseType: 'json',
              headers: {
                'Authorization': sessionStorage.getItem('profile_token')
              },
            })
            .then((response) => {
              // 
              this.isLoading=false;
              console.log("RESPONSE",response.data);
              this.article = response.data.data[0];
              // this.article.data = response.data.data[0].data;
              // this.article.ean = response.data.data[0].ean;
            }).catch((error) => {
              this.isLoading=false;
              alert("une erreur est survenue");
              console.log(error);
            });
  
  },
  data() {
    return {
      showNav:false,
      login_url :"",
      isLoading:false,
      isUserLogged: false,
      article: {},
      columns:[ 
        {
        field:"nom_carac",
        label:"Caractéristique"
      }
      ,
       {
        field:"value",
        label:"Valeur"
      },
       {
        field:"description",
        label:"Description"
      }
      ]
    }
  },
  methods: {
   
  },
  computed: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 20px;
  font-weight: bold;
}
.inside-card {
  max-width: 80%;
  margin: auto;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticlePage.vue